import { TripPayload } from 'store/trips/trips.types'
import { convertToTitleCase } from 'pages/trip/trip.utils'
import TripDetailsTableCell from '../trip-details-table-cell/trip-details-table-cell'
import {
  getEquipmentTaskLabel,
  isEquipmentTaskType,
} from '../trip-details-table/trip-details-table-body/trip-details-table-body.utils'

type TripDetailsTaskProps = {
  tripTask: TripPayload
}

const TripDetailsTask = ({ tripTask }: TripDetailsTaskProps) => {
  if (isEquipmentTaskType(tripTask.type)) {
    return (
      <TripDetailsTableCell
        value1={getEquipmentTaskLabel(tripTask.type)}
        value2={tripTask.name}
        minWidth={140}
      />
    )
  }

  return (
    <TripDetailsTableCell
      value1={convertToTitleCase(tripTask.type)}
      minWidth={140}
    />
  )
}

export default TripDetailsTask
